import { useState, useCallback } from 'react';
import { message } from 'antd';
import { d306Api, QueryParams, QueryResponse, UnitSummary, VendorSummary } from '../../../services/d306Api';

export function useD306Query() {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<QueryResponse | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);
  const [unitSummary, setUnitSummary] = useState<UnitSummary[]>([]);
  const [vendorSummary, setVendorSummary] = useState<VendorSummary[]>([]);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await d306Api.query(params);
      setResponse(resp);
      setUnitSummary(resp.unit_summary || []);
      if (resp.report_type === 2 && 'vendor_summary' in resp) {
        setVendorSummary(resp.vendor_summary || []);
      } else {
        setVendorSummary([]);
      }
      if (resp.data && resp.data.length > 0) {
        setNoData(false);
      } else {
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResponse(null);
    setUnitSummary([]);
    setVendorSummary([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, response, unitSummary, vendorSummary, queried, noData, runQuery, reset };
}
